<template>
    <ul>
      <li v-for="entry in $router.options.routes" v-if="entry.menu==menu">
        <kms-a :class="{ 'router-link-exact-active': entry.name == $route.name }" :to="entry.path">{{ entry.name }}</kms-a>
      </li>
    </ul>
</template>

<script>
export default {
  props: ['menu'],
  data () {
    return {

    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

ul {
  display: flex;
  width:100%;
  justify-content: center;
  &.vertical {
    flex-direction: column;
    li {
      line-height: 2em;
      margin:0;
      a {
        font-size:1em;
        font-weight: 500;
      }
    }
  }
  &.burger-nav{
    li{
      display: block;
      transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      text-align: center;
      &:first-of-type{
        margin: 30vw 3% 0 3%;
      }
      &:last-of-type{
        margin: 0 3%;
      }
      &:nth-child(1){
        transition-delay: 0.05s;
      }
      &:nth-child(2){
        transition-delay: 0.10s;
      }
      &:nth-child(3){
        transition-delay: 0.15s;
      }
      &:nth-child(4){
        transition-delay: 0.20s;
      }
      &:nth-child(5){
        transition-delay: 0.25s;
      }
      a{
        color: white;
        text-shadow: 10px 10px 5px rgba(0, 0, 0, 0.5);
        font-size:1.8em;
        line-height: normal;
        font-weight: 700;
        background:none;
        line-height: 3em
      }
    }
  }
   li {
    margin: 0 3%;
    &:first-of-type {
      margin-left:0;
    }
    &:last-of-type{
      @include for-size(tablet-portrait-up) {
        margin-right:0;
      }
    }

    a{
      font-family: $font-main;
      font-weight: bolder;
      color:white;
      text-decoration: none;
      line-height: 0;
      vertical-align: super;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Navigation.vue